import { render, staticRenderFns } from "./BaseFieldset.vue?vue&type=template&id=d474d0e6"
import script from "./BaseFieldset.vue?vue&type=script&lang=js"
export * from "./BaseFieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports